import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export const EmergencyFloatingButton = () => {
  return (
    <Link
      to="/emergency"
      className="fixed bottom-24 right-4 md:bottom-6 md:right-6 z-[110] bg-red-600 hover:bg-red-700 text-white p-3 rounded-full shadow-lg shadow-red-600/30 transition-all hover:scale-105 active:scale-95"
      aria-label="Emergency contacts"
      data-testid="emergency-floating-btn"
    >
      <AlertTriangle size={22} />
    </Link>
  );
};
